module.exports = __webpack_public_path__ + "img/Progress-Report-4.fa744268.png";